import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { formsV2 as Forms } from '@breezeway/brzw-components';

const { INPUT_SIZES, INPUT_WIDTH } = Forms.constants.input;

const InputFormik = ({
  additionalProps,
  className,
  disabled,
  field,
  form,
  id,
  label,
  placeholder,
  required,
  size,
  type,
  width,
}) => {
  const { errors, touched, setFieldValue, submitCount } = form;
  const { name } = field;
  let hasError = false;
  let errorName = null;
  const shouldHandleError = (touched[name] || submitCount > 0) && errors[name];

  if (shouldHandleError) {
    hasError = true;
    errorName = errors[name];
  }

  return (
    <Forms.Input
      {...field}
      additionalSubText={errorName}
      className={className}
      disabled={disabled}
      iconAfter={hasError && 'info-outline'}
      id={id || name}
      isRequired={required}
      labelText={label}
      onChange={value => setFieldValue(name, value)}
      placeholderText={placeholder}
      size={size}
      type={type}
      width={width}
      withError={hasError}
      {...additionalProps}
    />
  );
};

InputFormik.propTypes = {
  additionalProps: PropTypes.shape({}),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  field: PropTypes.shape({}),
  form: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  size: PropTypes.oneOfType([_.values(INPUT_SIZES)]),
  type: PropTypes.string,
  width: PropTypes.oneOfType([_.values(INPUT_WIDTH)]),
};

InputFormik.defaultProps = {
  additionalProps: {},
  className: '',
  required: false,
  type: 'text',
};

export default InputFormik;
